<template>
  <v-container fluid v-if="user != null">
    <user-edit-fields v-model="user" type="edit"></user-edit-fields>
  </v-container>
</template>
<script>
import UserEditFields from '../../components/UserEditFields.vue';

export default {
  name: 'UserEditView',
  components: { UserEditFields },
  computed: {
    user: {
      get() {
        return this.$store.getters.getUser(this.$route.params.id);
      },
      set(value) {
        this.$store.commit('updateUser', value);
        this.$router.push({ name: 'Users' });
      },
    },
  },
};
</script>
